/**
 * Get unique plate groups used in the experiment
 * @returns {Array} plate groups. Empty Array if no plate group available.
 */
export function getPlateGroupsExperiment(experiment) {
  const plates = getSamplePlates(experiment)
  const plateGroups = []
  const keys = {}
  plates.forEach(plate => {
    if (plate.plateGroup !== null) {
      const id = plate.plateGroup.plateGroupId
      if (keys[id] === null) {
        plateGroups.push(plate.plateGroup)
        keys[id] = true
      }
    }
  })
  return plateGroups
}

/**
 * Get sample plates of the experiment
 * @return {Array} sample plate list
 */
export function getSamplePlates(experiment) {
  return experiment.samplePlates
}

/**
 * Get plates for a given plateGroupId
 * @returns {array} plates in this experiment which are part to the plateGroup. Empty array is none found.
 */
export function getPlatesByPlateGroupId(experiment, plateGroupId) {
  const plates = getSamplePlates(experiment)
  const result = []
  for (let i = 0; i < plates.length; i++) {
    if (plates[i].plateGroup !== null) {
      if (plates[i].plateGroup.plateGroupId === plateGroupId) {
        result.push(plates[i])
      }
    }
  }
  return result
}

/**
 * Get specimens/samples of the experiment
 * @return {Array} all samples/specimens of the experiment

 */
export function getSamples(experiment) {
  return experiment.samples
}

/**
 * Get macromolecules of the experiment
 * @param {Object} experiment experiment
 * @return {Array} unique macromolecules of the experiment
 **/
export function getMacromolecules(experiment) {
  const specimens = getSamples(experiment)
  const macromoleculeIds = {}
  const macromolecules = []

  for (let i = 0; i < specimens.length; i++) {
    if (specimens[i].macromolecule) {
      if (!macromoleculeIds[specimens[i].macromolecule.macromoleculeId]) {
        macromolecules.push(specimens[i].macromolecule)
        macromoleculeIds[specimens[i].macromolecule.macromoleculeId] = true
      }
    }
  }
  return macromolecules
}

/** Associate a color to all buffers of the experiment */
export function mapBufferColorsToSpecimenIdByExperiment(experiment) {
  const specimens = getSamples(experiment)

  const bufferColors = ['#AED6F1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#2c7fb8', '#253494']

  // Get all buffers among specimens
  const bufferSpecimens = []
  for (let i = 0; i < specimens.length; i++) {
    if (!specimens[i].macromolecule) {
      bufferSpecimens.push(specimens[i])
    }
  }

  const mapper = {}
  for (let i = 0; i < bufferSpecimens.length; i++) {
    mapper[bufferSpecimens[i].specimenId] = bufferColors[i % bufferColors.length]
  }
  return mapper
}

export function mapMacromoleculeColorsToMacromoleculeIdByExperiment(experiment) {
  const macromolecules = getMacromolecules(experiment)

  const macromoleculesColors = ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494']

  const mapper = {}
  for (let i = 0; i < macromolecules.length; i++) {
    mapper[macromolecules[i].macromoleculeId] = macromoleculesColors[i % macromoleculesColors.length]
  }

  return mapper
}
